module.exports = __webpack_public_path__ + "static/media/banner-medio.c7df869a.jpeg";